declare namespace $ {

	type $shm_hitalama_map_widget_float_code_html_bench_result__state_shm_hitalama_map_widget_float_code_html_bench_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench['process_state'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench_result['state'] >
	>
	export class $shm_hitalama_map_widget_float_code_html_bench extends $shm_hitalama_map_widget_float_code_bench {
		Result_view( ): $shm_hitalama_map_widget_float_code_html_bench_result
	}
	
}

//# sourceMappingURL=bench.view.tree.d.ts.map